import api from './api';
import { ENDPOINTS } from '../utils/constants';
import { formatApiError, logError } from '../utils/errorHandler';

/**
 * Employee grower service functions
 */

/**
 * Get paginated/filtered list of growers (employee only)
 */
export const getEmployeeGrowers = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();

    if (params.search) searchParams.append('search', params.search);
    if (params.is_active !== undefined && params.is_active !== '')
      searchParams.append('is_active', params.is_active);
    if (params.page) searchParams.append('page', params.page);
    if (params.ordering) searchParams.append('ordering', params.ordering);

    const qs = searchParams.toString();
    const url = qs
      ? `${ENDPOINTS.GROWERS.EMPLOYEE.LIST}?${qs}`
      : ENDPOINTS.GROWERS.EMPLOYEE.LIST;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    logError('Get employee growers', error);
    throw formatApiError(error);
  }
};

/**
 * Get a single grower by ID
 */
export const getEmployeeGrower = async (id) => {
  try {
    const response = await api.get(ENDPOINTS.GROWERS.EMPLOYEE.DETAIL(id));
    return response.data;
  } catch (error) {
    logError('Get employee grower', error);
    throw formatApiError(error);
  }
};

/**
 * Create a new grower
 */
export const createGrower = async (data) => {
  try {
    const response = await api.post(ENDPOINTS.GROWERS.EMPLOYEE.LIST, data);
    return response.data;
  } catch (error) {
    logError('Create grower', error);
    throw formatApiError(error);
  }
};

/**
 * Update an existing grower (full PUT)
 */
export const updateGrower = async (id, data) => {
  try {
    const response = await api.put(ENDPOINTS.GROWERS.EMPLOYEE.DETAIL(id), data);
    return response.data;
  } catch (error) {
    logError('Update grower', error);
    throw formatApiError(error);
  }
};

/**
 * Partial update a grower (PATCH)
 */
export const patchGrower = async (id, data) => {
  try {
    const response = await api.patch(ENDPOINTS.GROWERS.EMPLOYEE.DETAIL(id), data);
    return response.data;
  } catch (error) {
    logError('Patch grower', error);
    throw formatApiError(error);
  }
};

/**
 * Soft-delete a grower (sets is_active=false)
 */
export const deleteGrower = async (id) => {
  try {
    await api.delete(ENDPOINTS.GROWERS.EMPLOYEE.DETAIL(id));
  } catch (error) {
    logError('Delete grower', error);
    throw formatApiError(error);
  }
};

/**
 * Get choices for certifications, growing practices, and products
 */
export const getGrowerChoices = async () => {
  try {
    const response = await api.get(ENDPOINTS.GROWERS.EMPLOYEE.CHOICES);
    return response.data;
  } catch (error) {
    logError('Get grower choices', error);
    throw formatApiError(error);
  }
};
